import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=f15f0704&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=f15f0704&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15f0704",
  null
  
)

export default component.exports